var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 10.75L35.5205 32.7125C35.1467 37.9455 30.7923 42 25.5459 42H18.454C13.2077 42 8.85325 37.9455 8.47946 32.7125L7 10.75M2 12C2 12 8.66667 9.5 22 9.5C35.3333 9.5 42 12 42 12M32 10.0178L31.7945 8.26701C31.1918 4.6506 28.0628 2 24.3965 2H19.6034C15.9372 2 12.8082 4.6506 12.2055 8.26701L12 10.0178M28.25 22V29.5M15.75 22V29.5M22 19.5L22 32",
    stroke: "#222222",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ec753496dc854d30f6a2ee975fa94ccf.svg";
export { ForwardRef as ReactComponent };